// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var PaymentTransactionController = function ($scope, $http, PaymentTransaction, $routeParams, PUtill,
                                             TransactionsDownloadByFilter, DatepickerUtils) {
    $scope.wasSearching = false;
    $scope.filter = '';
    $scope.search = '';
    $scope.status = '';
    $scope.excludePreauth = false;
    $scope.statusName = PUtill.getText('Status');
    $scope.dateRange = { dateFrom: null, dateTo: null };

    $scope.updateFilter = function (func) {
        $scope.transactions = $scope.paginator(function (options, callback) {
            return PaymentTransaction.query(options, function() {
                callback();
                $scope.wasSearching = options.search;
                if (func)
                    func();
                func = null;
            });
        }, getSearchParams(), 20);
    };

    $scope.statusClass = function (status) {
        switch (status) {
            case 'Succeeded':
            case 'PreliminarySucceeded':
                return "label-success";
            case 'Failed':
            case 'Chargeback':
                return "label-important";
            default:
                return '';
        }
    };
    $scope.statusClass = function (status) {
        return PUtill.getStatusClass(status);
    };
    $scope.setStatus = function (status, defaultLabelName) {
        $scope.status = status.replace(' ', '');
        $scope.statusName = PUtill.getText(defaultLabelName || status);
        $scope.updateFilter();
    };
    
    let getSearchParams = function () {
        let searchParams = {
            search: $scope.search,
            dateFrom: $scope.dateRange.dateFrom,
            dateTo: PUtill.addDay($scope.dateRange.dateTo),
            status: null,
            excludePreauth: false
        };
        
        if ($scope.excludePreauth)
            searchParams.excludePreauth = $scope.excludePreauth;
        
        if ($scope.status)
            searchParams.status = $scope.status;
        
        return searchParams;
    };
    $scope.downloadByFilter = function () {
        var searchParams = getSearchParams();
        searchParams.isDownload = true;
        var download = function () {
            $scope.isL = true;
            var downloadInfo = new TransactionsDownloadByFilter();
            downloadInfo.$save({
                isDownload: true,
                dateFrom: searchParams.dateFrom,
                dateTo: searchParams.dateTo,
                search: searchParams.search,
                status: searchParams.status,
                excludePreauth: searchParams.excludePreauth
            }, function () {
                window.location = downloadInfo.Url;
                $scope.isL = false;
            }, function () { $scope.isL = false; });
        };
        $scope.updateFilter(download);
    };
  
    function init() {
        if($routeParams.filter) {
            $scope.search = $routeParams.filter;
        }
        if (!$scope.search) {
            $scope.search = "";
        }
        $scope.updateFilter();
    }
    init();

};
PaymentTransactionController.$inject = ['$scope', '$http', 'PaymentTransaction', '$routeParams', 'PUtill',
    'TransactionsDownloadByFilter', 'DatepickerUtils'];
